import {
    IAtendimentoVendasRequest,
    IListarVendasResponse,
    TModoGestaoAtendimento,
} from "../../../Interfaces/Vendas/GestaoAtendimentos/AtendimentosVendas";
import {
    AvancarEtapaService,
    ListarAtendimentosVendasService,
    ListarAtendimentosVendasTransferirService,
    ListarEtapasCasoVendasService,
} from "../../../Services/Vendas/GestaoAtendimentosVendas/AtendimentosVendasServices";

import { Controller } from "../../Controller";

export async function ListarAtendimentosVendasController(
    data: IAtendimentoVendasRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(
        ListarAtendimentosVendasService<IListarVendasResponse>(
            data,
            pagina,
            SEG_ATENDIMENTOS,
            false
        )
    );
}

export async function ExportarExcelAtendimentosVendasController(
    data: IAtendimentoVendasRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(
        ListarAtendimentosVendasService<Blob>(data, 0, SEG_ATENDIMENTOS, true)
    );
}

export async function ListarAtendimentosVendasTransferirController(
    data: IAtendimentoVendasRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(
        ListarAtendimentosVendasTransferirService(data, SEG_ATENDIMENTOS)
    );
}

export async function ListarEtapasCasoVendasController(
    ID_CASO: number
) {
    return Controller(
        ListarEtapasCasoVendasService(ID_CASO)
    );
}

export async function AvancarEtapaController(
    idCaso: number,
    idEtapaDestino: number
) {
    return Controller(AvancarEtapaService(idCaso, idEtapaDestino));
}